import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/rv2oybj3_585bf8ac-0deb-49c3-af7b-11d9240feef9.JPG";

const Header = ({ cartItemCount }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={`network-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-wrapper">
        <Link to="/" className="network-logo">
          <img src={LOGO_URL} alt="Sole to Soul" className="logo-image" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="network-nav">
          <button onClick={() => scrollToSection('products')} className="network-nav-link">
            Products
          </button>
          <button onClick={() => scrollToSection('why-us')} className="network-nav-link">
            Why Us
          </button>
          <button onClick={() => scrollToSection('uses')} className="network-nav-link">
            Uses
          </button>
          <button onClick={() => scrollToSection('contact')} className="network-nav-link">
            Contact
          </button>
          <Link to="/cart" className="cart-link">
            <ShoppingCart size={20} />
            {cartItemCount > 0 && <span className="cart-badge">{cartItemCount}</span>}
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollToSection('products')} className="mobile-nav-link">
            Products
          </button>
          <button onClick={() => scrollToSection('why-us')} className="mobile-nav-link">
            Why Us
          </button>
          <button onClick={() => scrollToSection('uses')} className="mobile-nav-link">
            Uses
          </button>
          <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">
            Contact
          </button>
          <Link to="/cart" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>
            Cart ({cartItemCount})
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;